export const MIN_LEVEL = 1;
export const MAX_LEVEL = 11;
export const MIN_BATTLE = 0;
export const MAX_BATTLE = Number.MAX_SAFE_INTEGER;
export const MIN_PRICE = 0;
export const MAX_PRICE = 1000;
export const MAX_PRICE_THC = 15000;
export const ACTUAL_PRICE = 100000000;
export const TO_INF = 1.25;